import { render } from "./deptSelect.vue?vue&type=template&id=6eddc34a"
import script from "./deptSelect.vue?vue&type=script&lang=js"
export * from "./deptSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__